<template>
  <v-container>
    <PageHeader no-padding :title="title" />
    <v-progress-linear indeterminate v-if="isLoading"></v-progress-linear>
    <data-set-metadata-schema-detail-form v-if="isValid" :schema="schema" @change="onFormChange" @submit="onFormSubmit" @close="onFormClose" @delete="onFormDelete"></data-set-metadata-schema-detail-form>
    <v-card color="grey lighten-4">
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const app = createNamespacedHelpers('app')
  const rawdatarepository = createNamespacedHelpers('rawdatarepository')
  import DataSetMetadataSchemaDetailForm from './DataSetMetadataSchemaDetailForm'
  export default {
    components: {
      DataSetMetadataSchemaDetailForm,
    },
    props: {
      id: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        formSchema: {},
      }
    },
    computed: {
      ...rawdatarepository.mapGetters([
        'metadataSchemas',
        'metadataSchemaById',
      ]),
      isLoading() {
        return this.metadataSchemas.isLoading
      },
      isValid() {
        return this.schema != null
      },
      schema() {
        let schemaList = this.metadataSchemaById(this.id)
        return schemaList.length > 0 ?
          JSON.parse(JSON.stringify(schemaList[0])) :
          null
      },
      title() {
        return this.schema == null ? '' : this.schema.Name
      },
    },
    watch: {
      isLoading() {
        this.checkIfFileExists()
      },
    },
    methods: {
      ...app.mapActions(['setSnackbar']),
      ...rawdatarepository.mapActions(['getMetadataSchemas', 'putSchema', 'deleteSchema']),
      checkIfFileExists() {
        if (!this.isLoading && !this.isValid) {
          console.log(`unknown schema, ${this.id} redirecting`)
          this.$router.push('/manage/file-schemas')
        }
      },
      fetchMetadataSchemas({ forced, cb }) {
        if (cb == null) {
          cb = () => null
        }
        let options = {
          successCb: () => {
            this.checkIfFileExists()
            cb()
          },
          failedCb: err =>
            console.error('failed getting metadata schemas ', err),
          forced: forced || false,
        }
        this.getMetadataSchemas(options)
      },
      onFormChange(formSchema) {
        this.formSchema = formSchema
      },
      onFormClose() {
        console.log('closing time')
        this.$router.push('/manage/file-schemas')
      },
      onFormSubmit() {
        let options = {
          schemaId: this.id,
          payload: this.formSchema,
          successCb: () => {
            this.setSnackbar({
              color: 'success',
              text: `Schema ${
              this.schema.Name
              } updated successfully`,
            })
            this.fetchMetadataSchemas({
              forced: true,
            })
          },
          failedCb: err => console.error(err),
        }
        this.setSnackbar({
          color: 'info',
          message: 'Schema updates can take time depending on the number of files in the system. Please do not close your browser until the operation is complete.',
        })
        this.putSchema(options)
      },
      onFormDelete() {
        let options = {
          schemaId: this.id,
          payload: this.formSchema,
          isTestRun: false,
          successCb: () => {
            this.setSnackbar({
              color: 'success',
              text: `Schema ${
              this.schema.Name
              } removed successfully`,
            })
            this.fetchMetadataSchemas({
              forced: true,
            })
            this.$router.push('/manage/file-schemas')
          },
          failedCb: err => console.error(err),
        }
        this.setSnackbar({
          color: 'info',
          message: 'The schema is removed from the system.',
        })
        this.deleteSchema(options)
      },
    },
    mounted() {
      this.fetchMetadataSchemas({})
      this.formSchema = this.schema
    },
  }
</script>

<style lang="stylus" scoped></style>